export default "__VITE_PUBLIC_ASSET__b1d24503__"